import { useEffect, useState } from "react";
import { Header } from "../components/header";
import { trackEvent, trackPageView } from "../utils/segment";
import MangroveChefChallengeImage from "../assets/mangrove-chef-challenge.jpg";
import { cleanText } from "../utils";

export function ChefChallenge() {
  const [acceptedTCs, setAcceptedTCs] = useState(false);

  useEffect(() => {
    trackPageView("Landed on the Chef Challenge Page");
  }, []);

  useEffect(() => {
    if (acceptedTCs) {
      let userId = localStorage.getItem("ajs_user_id") ?? "";
      trackEvent("Opened Challenge Form");
      window.open(
        `https://form.typeform.com/to/iyUrwX0p?typeform-source=mangrovefoods.com&userid=${cleanText(
          userId
        )}`,
        "_blank"
      );
    }
  }, [acceptedTCs]);

  const handleEnterChallenge = () => {
    if (acceptedTCs) {
      let userId = localStorage.getItem("ajs_user_id") ?? "";
      trackEvent("Opened Challenge Form");
      window.open(
        `https://form.typeform.com/to/iyUrwX0p?typeform-source=mangrovefoods.com&userid=${cleanText(
          userId
        )}`,
        "_blank"
      );
      // setAcceptedTCs(true);
      // trackEvent("Accepted Chef Challenge TCs", { acceptedTCs });
    } else {
      trackEvent("Opened Terms and Conditions");
      document.getElementById("launch-tcs-button").click();
    }
  };

  return (
    <div className='chef-challenge-page'>
      <Header />
      <div className='hero-img-section'>
        <img src={MangroveChefChallengeImage} alt='mangrove-chef-challenge' />
      </div>

      {/* Challenge Introduction Section */}
      <div className='challenge-intro-section'>
        <div className='container'>
          <div className='intro-content'>
            <div className='intro-badge'>
              <i className='fas fa-trophy'></i>
              <span>Competition</span>
            </div>
            <h2 className='intro-title'>
              Mangrove <span className='gradient-text'>Chef Challenge</span>
            </h2>
            <p className='intro-description'>
              Think you've got the most creative recipe? Now's your chance to
              show the world. Join the Mangrove Chef Challenge and stand a
              chance to win exciting cash prizes while showcasing your cooking
              skills using Mangrove Foods.
            </p>

            <button
              className='cta-button primary modern-gradient-button'
              onClick={() => {
                const element = document.getElementById("how-to-enter-section");
                if (element) {
                  element.scrollIntoView({ behavior: "smooth" });
                }
              }}
            >
              <div className='button-inner'>
                <div className='button-icon-wrapper'>
                  <i className='fas fa-rocket'></i>
                </div>
                <div className='button-text-wrapper'>
                  <span className='button-sub-text'>Enter the Challenge</span>
                </div>
                <div className='button-arrow'>
                  <i className='fas fa-arrow-right'></i>
                </div>
              </div>
              <div className='button-shine'></div>
              <div className='button-ripple'></div>
            </button>
          </div>
        </div>
      </div>

      {/* How to Enter Section */}
      <div className='how-to-enter-section' id='how-to-enter-section'>
        <div className='section-header'>
          <h2>How to Enter</h2>
          <p>Follow these simple steps to participate in the challenge</p>
        </div>

        <div className='steps-container'>
          <div className='step-card'>
            <div className='step-number'>1</div>
            <div className='step-content'>
              <h3>Follow Us Online</h3>
              <p>Follow @MangroveFoods on all our social media platforms</p>
              <div className='social-links'>
                <a
                  href='https://www.instagram.com/mangrove.foods/'
                  target='_blank'
                  rel='noopener noreferrer'
                >
                  <i className='fab fa-instagram'></i>
                  Instagram
                </a>
                <a
                  href='https://www.tiktok.com/@mangrovefoods'
                  target='_blank'
                  rel='noopener noreferrer'
                >
                  <i className='fab fa-tiktok'></i>
                  TikTok
                </a>
                <a
                  href='https://web.facebook.com/profile.php?id=61578690178560'
                  target='_blank'
                  rel='noopener noreferrer'
                >
                  <i className='fab fa-facebook'></i>
                  Facebook
                </a>
                <a
                  href='https://x.com/MangroveFoods'
                  target='_blank'
                  rel='noopener noreferrer'
                >
                  <i className='fab fa-twitter'></i>X (Twitter)
                </a>
              </div>
            </div>
          </div>

          <div className='step-card'>
            <div className='step-number'>2</div>
            <div className='step-content'>
              <h3>Create Your Recipe Video</h3>
              <p>
                Cook up a fun, unique, and creative recipe using any Mangrove
                Foods product — from sardines to sweet corn, baked beans, green
                peas, or kidney beans.
              </p>
            </div>
          </div>

          <div className='step-card'>
            <div className='step-number'>3</div>
            <div className='step-content'>
              <h3>Post Your Video</h3>
              <p>
                Upload your recipe video to Instagram (Reels) or TikTok with
                proper tagging and hashtags.
              </p>
            </div>
          </div>

          <div className='step-card'>
            <div className='step-number'>4</div>
            <div className='step-content'>
              <h3>Tag & Hashtag</h3>
              <p>Tag @MangroveFoods and include the hashtags:</p>
              <div className='hashtags'>
                <span className='hashtag'>#MangroveChefChallenge</span>
                <span className='hashtag'>#MangroveFoods</span>
                <span className='hashtag'>#MangroveStandard</span>
              </div>
            </div>
          </div>

          <div className='step-card'>
            <div className='step-number'>5</div>
            <div className='step-content'>
              <h3>Submit Your Entry</h3>
              <p>
                Once you've posted your video on Instagram or TikTok, submit the
                link to your post to complete your entry.
              </p>
              <button
                className='submit-entry-button'
                onClick={handleEnterChallenge}
              >
                <i className='fas fa-paper-plane'></i>
                Submit Entry Link
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Prizes Section */}
      <div className='prizes-section'>
        <div className='section-header'>
          <h2>Prizes to Be Won</h2>
          <p>The top 3 entries will each walk away with amazing cash prizes</p>
        </div>

        <div className='prizes-container'>
          <div className='prize-card first-place'>
            <div className='prize-icon'>🥇</div>
            <div className='prize-content'>
              <h3>1st Place</h3>
              <div className='prize-amount'>₦300,000</div>
              {/* <p>Grand Prize Winner</p> */}
            </div>
          </div>

          <div className='prize-card second-place'>
            <div className='prize-icon'>🥈</div>
            <div className='prize-content'>
              <h3>2nd Place</h3>
              <div className='prize-amount'>₦200,000</div>
              {/* <p>Runner-up</p> */}
            </div>
          </div>

          <div className='prize-card third-place'>
            <div className='prize-icon'>🥉</div>
            <div className='prize-content'>
              <h3>3rd Place</h3>
              <div className='prize-amount'>₦100,000</div>
              {/* <p>Second Runner-up</p> */}
            </div>
          </div>
        </div>
      </div>

      {/* Judging Criteria Section */}
      <div className='judging-section'>
        <div className='section-header'>
          <h2>How We’ll Pick Winners</h2>
          <p>Entries will be evaluated based on these key factors</p>
        </div>

        <div className='criteria-container'>
          <div className='criteria-card'>
            <div className='criteria-icon'>
              <i className='fas fa-lightbulb'></i>
            </div>
            <h3>Creativity (40%)</h3>
            <p>How unique and imaginative your recipe is</p>
          </div>

          <div className='criteria-card'>
            <div className='criteria-icon'>
              <i className='fas fa-video'></i>
            </div>
            <h3>Presentation & Video Quality (30%)</h3>
            <p>How clear, appealing, and polished your video looks</p>
          </div>

          <div className='criteria-card'>
            <div className='criteria-icon'>
              <i className='fas fa-heart'></i>
            </div>
            <h3>Storytelling (30%)</h3>
            <p>How engaging and relatable your entry feels</p>
          </div>
        </div>
      </div>

      {/* Timeline Section */}
      <div className='timeline-section'>
        <div className='section-header'>
          <h2>Contest Timeline</h2>
          <p>Important dates and milestones</p>
        </div>

        <div className='timeline-container'>
          <div className='timeline-item'>
            <div className='timeline-date'>
              <span className='date'>Sep 22</span>
              <span className='year'>2025</span>
            </div>
            <div className='timeline-content'>
              <h3>Entries Open</h3>
              <p>Start submitting your creative recipes</p>
            </div>
          </div>

          <div className='timeline-item'>
            <div className='timeline-date'>
              <span className='date'>Oct 20</span>
              <span className='year'>2025</span>
            </div>
            <div className='timeline-content'>
              <h3>Entries Close</h3>
              <p>Last day to submit your entries</p>
            </div>
          </div>

          <div className='timeline-item'>
            <div className='timeline-date'>
              <span className='date'>Oct 21-23</span>
              <span className='year'>2025</span>
            </div>
            <div className='timeline-content'>
              <h3>Selections</h3>
              <p>Top 5 selected and reposted</p>
            </div>
          </div>

          <div className='timeline-item'>
            <div className='timeline-date'>
              <span className='date'>Oct 25-27</span>
              <span className='year'>2025</span>
            </div>
            <div className='timeline-content'>
              <h3>Voting Begins</h3>
              <p>Top 5 entries reposted for audience voting</p>
            </div>
          </div>

          <div className='timeline-item'>
            <div className='timeline-date'>
              <span className='date'>Oct 28-29</span>
              <span className='year'>2025</span>
            </div>
            <div className='timeline-content'>
              <h3>Votes Collation</h3>
              <p>Votes collated and top 3 selected</p>
            </div>
          </div>

          <div className='timeline-item'>
            <div className='timeline-date'>
              <span className='date'>Oct 30</span>
              <span className='year'>2025</span>
            </div>
            <div className='timeline-content'>
              <h3>Winners Announced</h3>
              <p>Final winners revealed on social media</p>
            </div>
          </div>
        </div>
      </div>

      {/* Why Join Section */}
      <div className='why-join-section'>
        <div className='section-header'>
          <h2>Why Join the Challenge?</h2>
          {/* <p>This is your opportunity to showcase your talent</p> */}
        </div>

        <div className='benefits-container'>
          <div className='benefit-item'>
            <div className='benefit-icon'>
              <i className='fas fa-star'></i>
            </div>
            <h3>Showcase Your Talent</h3>
            <p>Display your cooking skills to a wide audience</p>
          </div>

          <div className='benefit-item'>
            <div className='benefit-icon'>
              <i className='fas fa-users'></i>
            </div>
            <h3>Gain Exposure</h3>
            <p>Get featured on Mangrove Foods' official pages</p>
          </div>

          <div className='benefit-item'>
            <div className='benefit-icon'>
              <i className='fas fa-trophy'></i>
            </div>
            <h3>Compete Nationwide</h3>
            <p>Compete with food lovers across Nigeria</p>
          </div>

          <div className='benefit-item'>
            <div className='benefit-icon'>
              <i className='fas fa-money-bill-wave'></i>
            </div>
            <h3>Win Cash Prizes</h3>
            <p>Take home amazing cash rewards</p>
          </div>
        </div>
      </div>

      {/* CTA Section */}
      <div className='final-cta-section'>
        <div className='cta-content'>
          <h2>Show Us Your Mangrove Standard!</h2>
          <p>
            Think you've got what it takes? Enter the Mangrove Chef Challenge
            today and let your creativity shine.
          </p>
          <button className='final-cta-button' onClick={handleEnterChallenge}>
            <i className='fas fa-rocket'></i>
            Enter Challenge Now
          </button>
        </div>
      </div>

      {/* Hidden Form */}
      {/* {showForm && (
        <div className='challenge-form-overlay'>
          <div className='form-container'>
            <button className='close-form' onClick={() => setShowForm(false)}>
              <i className='fas fa-times'></i>
            </button>
            <div
              data-tf-live='01K4MV43H1FSQ8N8884YY0BSRX'
              data-tf-transitive-search-params='utm_source,utm_medium,utm_campaign,utm_term,utm_content,fbclid,fbc,ttclid'
              style={{ width: "100%", height: "100%" }}
              data-tf-on-ready='onCampusFormReady'
              data-tf-on-submit='onCampusFormSubmit'
              data-tf-on-started='onCampusFormStarted'
              data-tf-on-ending-button-click='onCampusFormEndButtonClicked'
              data-tf-on-question-changed='onCampusFormQuestionChanged'
            ></div>
          </div>
        </div>
      )} */}

      <button
        type='button'
        className='btn btn-primary'
        style={{ display: "none" }}
        data-bs-toggle='modal'
        data-bs-target='#staticBackdrop'
        id='launch-tcs-button'
      >
        Launch Terms & Conditions modal
      </button>

      <TermsAndConditionModal
        accept={() => {
          setAcceptedTCs(true);
          trackEvent("Accepted Terms and conditions");
        }}
      />
    </div>
  );
}

function TermsAndConditionModal({ accept }) {
  return (
    <>
      <div
        className='modal fade'
        tabIndex='-1'
        role='dialog'
        aria-hidden='true'
        id='staticBackdrop'
        data-bs-backdrop='modal'
        // data-bs-keyboard='false'
        tabindex='-1'
        aria-labelledby='staticBackdropLabel'
      >
        <div
          className='modal-dialog modal-dialog-centered modal-dialog-scrollable'
          role='document'
        >
          <div className='modal-content'>
            <div className='modal-header'>
              <h3 className='modal-title' id='exampleModalLongTitle'>
                Mangrove Chef Challenge Terms and Conditions
              </h3>
              {/* <button
                type='button'
                className='close'
                data-dismiss='modal'
                aria-label='Close'
              >
                <span aria-hidden='true'>&times;</span>
              </button> */}
            </div>
            <div className='modal-body'>
              By participating in the Mangrove Chef Challenge ("the Contest"),
              you agree to be bound by these Official Rules and the decisions of
              Mangrove Foods, which are final and binding in all matters related
              to the Contest.
              <br />
              <br />
              <h4>1. Eligibility</h4>
              The Contest is open only to legal residents of Nigeria who are
              eighteen (18) years of age or older at the time of entry.
              Employees of Mangrove Foods and their immediate family members
              (spouse, parents, siblings, and children) are not eligible to
              participate.
              <br />
              <br />
              <h4>2. Contest Period</h4>
              The Contest begins on the launch date and runs for a period of
              three (3) weeks. Entries submitted before or after the Contest
              Period will be disqualified.
              <br />
              <br />
              <h4>3. How to Enter</h4>
              To enter the Contest, participants must complete the following
              steps during the Contest Period:
              <ul>
                <li>
                  <b>Follow:</b> You must follow <b>@MangroveFoods</b> on all
                  social media platforms:{" "}
                  <b>Instagram, TikTok, Facebook, or X.</b>
                </li>
                <li>
                  <b>Create:</b> Produce a video that features at least one
                  Mangrove Foods product, clearly visible in the video.
                </li>
                <li>
                  <b>Post:</b> Upload the video to your personal Instagram
                  account (as a Reel) or TikTok account.
                </li>
                <li>
                  <b> Tag & Hashtag:</b> The post must tag @Mangrove.Foods and
                  include the hashtags <b>#MangroveFoods #MangroveStandard</b>{" "}
                  and <b>#MangroveChefChallenge</b>.
                </li>
              </ul>
              Multiple entries are allowed per participant, but only one (1)
              entry per participant will be considered for shortlisting. Entries
              must not contain any offensive, obscene, or inappropriate content.
              <br />
              <br />
              <h4>4. Judging & Winner Selection</h4>
              Entries will be judged by a panel of judges on the following
              criteria:
              <br />
              <ul>
                <li>
                  <b>Creativity (40%):</b> The uniqueness of the recipe and
                  overall idea.
                </li>
                <li>
                  <b>Presentation & Video Quality (30%):</b> The clarity, visual
                  appeal, and effort demonstrated in the video.
                </li>
                <li>
                  <b>Storytelling/Relatability (30%):</b> How well the content
                  resonates with Nigerian audiences in a fun, inspiring, or
                  engaging manner.
                </li>
                <li>
                  <b>Shortlisting: </b> The top five (5) finalists will be
                  selected by the judging panel during the third week of the
                  Contest.
                </li>
                <li>
                  <b>Finalists & Voting:</b> The top three (3) winners will be
                  selected from the five finalists through an audience voting
                  process conducted on Mangrove Foods' social media channels.
                  Mangrove Foods reserves the right to monitor entries for
                  fraudulent activity, including the use of fake likes or vote
                  manipulation. Any entries found engaging in such practices
                  will be disqualified.
                </li>
                <li>
                  <b>Winner Announcement:</b> Winners will be announced within
                  seven (7) days after the Contest Period closes and will be
                  contacted via DM/Email.
                </li>
              </ul>
              <br />
              <h4>5. Prizes</h4>
              <ul>
                <li>
                  <b>1st Place:</b> ₦300,000
                </li>
                <li>
                  <b>2nd Place:</b> ₦200,000
                </li>
                <li>
                  <b>3rd Place:</b> ₦100,000
                </li>
              </ul>
              Prizes are non-transferable and may not be substituted or
              exchanged except as explicitly stated.
              <br />
              <br />
              <h4>6. Rights & Permissions</h4>
              By submitting an entry, you grant Mangrove Foods a worldwide,
              perpetual, royalty-free, non-exclusive license to use, reproduce,
              modify, publish, distribute, and display the submitted content in
              any media, including but not limited to social media, websites,
              and other marketing materials, with appropriate credit to the
              participant. You also agree to be featured in promotional
              materials related to the Contest.
              <br />
              <br />
              <h4>7. General Conditions</h4>
              Mangrove Foods reserves the right, in its sole discretion, to
              disqualify any individual who tampers with the entry process or
              acts in an unsportsmanlike or disruptive manner. Mangrove Foods
              reserves the right to modify, suspend, or terminate the Contest at
              any time without prior notice.
              <br />
              <br />
              <h4>8. Limitation of Liability</h4>
              By participating, you agree to release and hold harmless Mangrove
              Foods, its affiliates, and their respective officers, directors,
              employees, and agents from any and all liability, claims, or
              causes of action arising out of or related to your participation
              in the Contest or receipt of any prize.
              <br />
              <br />
              <h4>9. Disclaimer</h4>
              This Contest is in no way sponsored, endorsed, or administered by,
              or associated with, Instagram, TikTok, Facebook, or X. You
              understand that you are providing your information to Mangrove
              Foods and not to these platforms.
            </div>
            <div className='modal-footer'>
              <button
                type='button'
                data-bs-dismiss='modal'
                className='btn btn-danger'
              >
                Close
              </button>
              <button
                type='button'
                className='btn btn-primary'
                data-bs-dismiss='modal'
                onClick={accept}
              >
                Accept these Terms and conditions
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
